exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dpae-custom-tooltip.tooltip-inner[data-v-61323044] {\n\tbackground-color: white !important;\n\tcolor: black !important;\n}\n.dpae-custom-tooltip.arrow[data-v-61323044] {\n\tbackground-color: white !important;\n}\n.text-start[data-v-61323044] {\n\ttext-align: start !important;\n}\n#dpaetooltip[data-v-61323044] {\n\topacity: 1 !important;\n}\n#dpaetooltip .tooltip.b-tooltip[data-v-61323044] {\n\topacity: 1 !important;\n}\n.missing-info-title[data-v-61323044] {\n\tfont-weight: bold;\n\tfont-size: 15px;\n\tpadding-bottom: 5px;\n}\n.missing-info-sub-title[data-v-61323044] {\n\tfont-weight: 600;\n}\n", ""]);

// exports
